import { LOCAL_STORAGE_KEY_COMPANY_PERSONALIZATION } from './constants/queryConstants'

export const moneyFormat = (number) =>
  `$${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`

export const locationFormat = (loc) =>
  loc ? `${loc.slice(0, 3)}-${loc.slice(3, 5)}-${loc.slice(5)}` : '-'

export const toClientState = (state) => {
  const mapper = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 4,
    6: 4,
    7: 5
  }

  return mapper[parseInt(state, 10)]
}

export const login = (token) => {
  const loginToken = token

  localStorage.setItem('token', loginToken)
}

export const getIconData = async (companyPersonalization) => {
  const { baseIconPath } = companyPersonalization

  const timestamp = companyPersonalization.timestamp
    ? companyPersonalization.timestamp
    : ''

  return { baseIconPath, timestamp }
}

export const getLocalStorageKey = (token) => `${LOCAL_STORAGE_KEY_COMPANY_PERSONALIZATION}_${token}`

export const getCompanyPersonalizationFromStorage = () => {
  const token = localStorage.getItem('token')
  const storageKey = getLocalStorageKey(token)
  const savedData = localStorage.getItem(storageKey)
  if (savedData) {
    try {
      return JSON.parse(savedData)
    } catch (error) {
      console.error('Invalid company personalization data in localStorage:', error)
      localStorage.removeItem(storageKey)
    }
  }
  return null
}
